import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Stack, Paper, Typography, Divider, Grid, Box } from "@mui/material";
import { Formik } from "formik";
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";

import Layout from "../../../components/layout/Layout";
import Table from "../../../components/form/TableDetail";
import InputTextDetail from "../../../components/form/InputTextDetail";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import Skeleton from "../../../components/form/Skeleton";
import validator from "./validator";

import { getInvoiceRouteId } from "../../../store/masters/thunk/invoice/getId";

const NewEdit = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [__] = useTranslation("invoiceRoute");
    const { id } = useParams();
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "put" })
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })

    const user = useSelector(state => state.auth.login.dataUser);
    const put = useSelector((state) => state.masters.zone.put);
    const current = useSelector(state => state.masters.zone.detail);

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const setError = (err, action) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        } else {
            setAlert({
                open: true,
                type: "default",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

    useEffect(() => {
        if (!!id) {
            dispatch(getInvoiceRouteId({ id }))
        }
    }, [dispatch, id])

    const headTable = [
        {
          key: "squad",
          label: __(`tableDetail.cols.squad`),
          align: "left"
        },
        {
          key: "amount",
          label: __(`tableDetail.cols.amount`),
          align: "left"
        },
        {
          key: "billingCode",
          label: __(`tableDetail.cols.billingCode`),
          align: "left"
        },
        {
          key: "comment",
          label: __(`tableDetail.cols.comment`),
          align: "left"
        },
        {
          key: "unitPrice",
          label: __(`tableDetail.cols.unitPrice`),
          align: "left"
        },
        {
          key: "weight",
          label: __(`tableDetail.cols.weight`),
          align: "left"
        },
        {
          key: "pallets",
          label: __(`tableDetail.cols.pallets`),
          align: "left"
        },
        {
          key: "amountWithoutVAT",
          label: __(`tableDetail.cols.amountWithoutVAT`),
          align: "left"
        }
      ]

      const dataTable = map(get("deliveryPoints", "data", []), (row, i) => ({
        ...row
      }))

    const initialValues = {
        invoiceId: id ? get(current, "data.invoiceId", "") :  "",
        date: id ? get(current, "data.date", "") : "",
        state: id ? get(current, "data.state", "") :  "",
        receptionId: id ? get(current, "data.receptionId", "") : "",
        type: id ? get(current, "data.type", "") :  "",
        division: id ? get(current, "data.dision", "") : "",
        client: id ? get(current, "data.client", "") :  "",
        salesOrder: id ? get(current, "data.salesOrder", "") : "",
        inName: id ? get(current, "data.inName", "") : "",
        creationUser: id ? get(current, "data.creationUser", "") :  "",

        idUser: get(user, "idUser"),
    }

    return (
        <Layout
            propsToolbar={{
                title: !id ? __(`head.new.name`) : __(`head.detail.name`),
                srute: !id ? __(`head.new.code`) : id
            }}
        >
            {get(current, "isLoading")
                ? (
                <Skeleton /> 
            ) : ( 
                <Formik initialValues={initialValues} validationSchema={validator(__)}>
                    {formik => (
                        <form onSubmit={get(formik, "handleSubmit")}>
                            <Paper className='p-4'>
                                <Stack direction="row" spacing={2} justifyContent="flex-end">
                                    <Button className='w-[100px] min-w-[100px]' variant='outlined' color="secondary" onClick={() => navigate("/masters/invoices")} disabled={get(put, "isLoading")} >{__(`action.cancel`)}</Button>
                                </Stack>
                            </Paper>
                            <Paper className='mt-4'>
                                <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                                    <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                                </Stack>
                                <Divider />
                                <Box className='p-4' >
                                    <Grid container spacing={{ xs: 2, md: 3 }}>
                                        <Grid item xs={12} sm={4} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="invoiceId"
                                                label={__(`form.invoiceId.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="date"
                                                label={__(`form.date.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="state"
                                                label={__(`form.state.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="receptionId"
                                                label={__(`form.receptionId.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="type"
                                                label={__(`form.type.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="division"
                                                label={__(`form.division.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={8} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="client"
                                                label={__(`form.client.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="salesOrder"
                                                label={__(`form.salesOrder.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={8} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="inName"
                                                label={__(`form.inName.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="creationUser"
                                                label={__(`form.creationUser.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Paper>
                            <Paper className='mt-4 p-4'>
                                <Table headTable={headTable}
                                        dataTable={dataTable}
                                        __={__}
                                        sizeFilters={125}
                                        loading={get("deliveryPoints", "isLoading", false)}
                                    />
                            </Paper>
                            <Paper className='mt-4'>
                                <Box className='p-4' >
                                    <Grid container spacing={{ xs: 2, md: 3 }}>
                                        <Grid item xs={12} sm={4} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="subTotal"
                                                label={__(`form.subTotal.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="vat"
                                                label={__(`form.vat.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="total"
                                                label={__(`form.total.label`)}
                                                disabled={get(put, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} >
                                            <InputTextDetail
                                                formik={formik}
                                                name="comment"
                                                label={__(`form.comment.label`)}
                                                disabled={get(put, "isLoading", false)}
                                                multiline
                                                rows={3}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>    
                            </Paper>
                        </form>
                    )}
                </Formik>
            )}
            <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
            <Alert
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
        </Layout>
    )
}

export default NewEdit